module.exports = __webpack_public_path__ + "static/media/consistency.edd07020.svg";